//BetBy游戏ID
export const BetByGameId = 102804001;
//FirstSport游戏ID
export const FirstSportGameId = 1052001;
//FirstSport游戏ID
export const GameLineSportId = 1098002;

export const sportsGameList = [FirstSportGameId, BetByGameId, GameLineSportId];

//不需要进入的游戏ID
export const noEntryGameList = [
  5101, 1101, 1111, 7001, 7002, 7003, 7004, 7005, 7006, 7007, 7100,
];
export const betbyConfig = {
  key: "28bd746175404e2e90fa309a571601ed",
  widgetName: "promo",
  placeholder: "operator_page",
};
export enum GameTag {
  top = "1",
  hot = "2",
  new = "3",
  champs = "4",
}

export enum gclassEnum {
  original = 10,
  special = 1,
  slots = 2,
  live = 3,
  sport = 4,
  shows = 5,
  lottery = 6,
}

/** 游戏分类枚举 */
export enum GCLASS {
  SPECIAL = 1,
  SLOTS = 2,
  LIVE = 3,
  SPORT = 4,
  SHOWS = 5,
  LOTTERY = 6,
  ORIGINAL = 10,
  /** 体验金游戏 */
  TRIAL = "trial",
  /** 彩金游戏 */
  BONUS = "bonus",
}

export enum GameTypeMap {
  /** 体验金游戏 */
  TRIAL = "trial",
  /** 彩金游戏 */
  BONUS = "bonus",
}

export const GclassIconMap: Record<number, string> = {
  [gclassEnum.live]: "new-live-casino",
  [gclassEnum.slots]: "new-slot",
  [gclassEnum.original]: "new-originals",
  [gclassEnum.special]: "new-special",
  [gclassEnum.shows]: "new-show",
  [gclassEnum.sport]: "new-sports",
  [gclassEnum.lottery]: "new-lottery",
};

export const GclassNameMap: Record<number, string> = {
  [gclassEnum.live]: "live",
  [gclassEnum.slots]: "slot",
  [gclassEnum.original]: "original",
  [gclassEnum.special]: "special",
  [gclassEnum.shows]: "show",
  [gclassEnum.sport]: "sport",
  [gclassEnum.lottery]: "lottery",
};
